import React from 'react'
import { useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import ActionButtons from 'redesign/components/organisms/action-buttons'
import HeaderWithBackButton from 'redesign/components/organisms/headers/header-with-back-button'
import BalanceModal from 'redesign/components/organisms/modals/balance-modal'
import Page from 'redesign/components/templates/Page'
import NewAbsenceRequestContent from 'redesign/components/templates/new-absence-request-content'
import { STANDARD_PAGE_HORIZONTAL_PADDING } from 'shared/constants'
import PinLogin from '../pin-login'
import { useActionButtons } from './hooks/use-action-buttons'
import { useNewAbsenceRequestPage } from './hooks/use-new-absence-request-page'

const NewAbsenceRequestPage: React.FC = () => {
  const { palette } = useTheme()
  const { t } = useFavurTranslation()
  const props = useNewAbsenceRequestPage()
  const {
    loadingMutation,
    loading,
    onSubmit,
    setIsBalanceDrawerOpen,
    isBalancesDrawerOpen,
    formFields: {
      personUuid: { value: personUuid },
    },
  } = props
  const loadingContent = loadingMutation || loading
  const actionButtons = useActionButtons({
    onSubmit,
    setIsBalanceDrawerOpen,
    balanceDisabled: !personUuid,
  })

  return (
    <PinLogin>
      <Page
        header={<HeaderWithBackButton title={t('absenceRequest.title')} />}
        footer={<ActionButtons {...actionButtons} />}
        paddingX={STANDARD_PAGE_HORIZONTAL_PADDING}
        removeLastMargin
        hideNativeNavigation
        backgroundColor={palette.background.base}
      >
        {loadingContent ? <LoadingSpinner /> : <NewAbsenceRequestContent {...props} />}
        <BalanceModal
          selectedPersonUuid={personUuid as string}
          open={isBalancesDrawerOpen}
          onClose={() => setIsBalanceDrawerOpen(false)}
        />
      </Page>
    </PinLogin>
  )
}

export default NewAbsenceRequestPage
